import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right--sprite",
  "use": "arrow-right--sprite-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-right--sprite\">\n<path d=\"M0.0771484 12.4863L1.25715 13.6663L7.92381 6.99967L1.25715 0.333008L0.0771484 1.51301L5.56381 6.99967L0.0771484 12.4863Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol